<app-person-reg-online-form
[formData]="data"
[buttonCaption]="'Сохранить'"
[isAdminEdit]="true"
(onSubmitted)="onSubmit($event)"></app-person-reg-online-form>
